// TODO doplnit typy

export const transformDistanceFeeValues = (formData: any): any[] => {
    if (!formData) {
        return []
    }

    return formData.distanceFeeValues.map((val, index) => ({
        pairId: index,
        ...val,
    }))
}

export const DELIVERY_SETTINGS_PICKER_COOKIE = "delivery-settings-picker-selected-id"

export const DEFAULT_DISTANCE_FEE_VALUES = [
    {
        distance: 1,
        fee: 1,
    },
    {
        distance: 2,
        fee: 2,
    },
    {
        distance: 3,
        fee: 3,
    },
    {
        distance: 4,
        fee: 4,
    },
]
